import { Directive, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { combineLatest, map, Observable } from 'rxjs';

import {
  AuthService,
  contractStatusConverter,
  getContracts,
  getMasterDataChangeConfiguration,
  getTicketSettings,
  IMasterdataChangeConfiguration,
  LoadMasterDataChangeConfiguration,
  masterdataHelper,
  RequestLogout,
} from '../../../shared';
import { CustomerService, RouterService } from '../../services';

@Directive()
export class UserPageBaseComponent {
  protected activeRoute = inject(ActivatedRoute);

  private store = inject(Store);
  private customerService = inject(CustomerService);

  public routerService = inject(RouterService);
  public authService = inject(AuthService);
  public showProfileButton$: Observable<boolean>;
  public masterDataChangeConfiguration: IMasterdataChangeConfiguration[] | null;
  public hasMasterDataChangeConfig = signal(false);

  constructor() {
    this.store.dispatch(LoadMasterDataChangeConfiguration());
    this.showProfileButton$ = combineLatest([
      this.store.select(getContracts),
      this.store.select(getTicketSettings),
      this.store.select(getMasterDataChangeConfiguration),
    ]).pipe(
      map(([contracts, ticketSettings, masterDataChangeConfiguration]) => {
        const activeContract =
          contracts?.length && contractStatusConverter.isAnyContractActive(contracts);
        const contractlessTicketCreation =
          ticketSettings?.allowContractlessTicketCreationForOtherConcerns ?? false;
        const disabledTicketManagement = this.customerService.hideTicketManagement();

        this.masterDataChangeConfiguration = masterDataChangeConfiguration;
        this.hasMasterDataChangeConfig.set(masterDataChangeConfiguration?.length > 0);

        return masterdataHelper.checkShowChangeButton(
          masterDataChangeConfiguration,
          activeContract,
          contractlessTicketCreation,
          disabledTicketManagement
        );
      })
    );
  }

  public goToProfile() {
    void this.routerService.navigate(['profile'], { relativeTo: this.activeRoute });
  }

  public goToPrivacy() {
    void this.routerService.navigate(['privacy'], { relativeTo: this.activeRoute });
  }

  public goToDelete() {
    void this.routerService.navigate(['delete'], { relativeTo: this.activeRoute });
  }

  public goToLegal() {
    void this.routerService.navigate(['legal'], { relativeTo: this.activeRoute });
  }

  public goToFaq() {
    void this.routerService.navigate(['faq'], { relativeTo: this.activeRoute });
  }

  public goBack(): void {
    this.routerService.back();
  }

  public logoutUser(): void {
    this.store.dispatch(RequestLogout({ reason: 'auth', userInitiated: true }));
  }
}
